'use client';

import React from 'react';
import Link from 'next/link';
import { RefreshCw, Compass } from 'lucide-react';
import './globals.css';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en" className="dark">
      <body className="min-h-screen bg-[#030712] text-white flex flex-col items-center justify-center p-4">
        <div className="w-full max-w-lg text-center space-y-6">
          <div className="font-['Lexend'] text-7xl sm:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-b from-white/40 to-white/10 select-none tracking-widest">
            500
          </div>
          <div className="space-y-2">
            <h1 className="text-2xl sm:text-3xl font-['Lexend'] font-semibold text-white tracking-tight">
              Application Error
            </h1>
            <p className="text-sm text-[rgba(220,236,255,0.75)] max-w-md mx-auto leading-relaxed">
              A critical error occurred. Please try reloading the page.
            </p>
          </div>
          <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
            <button
              type="button"
              onClick={() => reset()}
              className="w-full sm:w-auto h-11 px-6 rounded-full bg-white hover:bg-[#e6edff] text-[#050a24] font-semibold text-sm shadow-md transition-all flex items-center justify-center gap-2 cursor-pointer"
            >
              <RefreshCw className="w-4 h-4 text-[#050a24]" />
              <span>Try Again</span>
            </button>
            <Link href="/" className="w-full sm:w-auto">
              <button
                type="button"
                className="w-full sm:w-auto h-11 px-6 rounded-full bg-white/[0.08] hover:bg-white/[0.14] border border-white/20 text-white font-semibold text-sm shadow-sm transition-all flex items-center justify-center gap-2 cursor-pointer"
              >
                <Compass className="w-4 h-4 text-[#5ab4ff]" />
                <span>Return Home</span>
              </button>
            </Link>
          </div>
        </div>
      </body>
    </html>
  );
}
